import React from "react"
import Link from "next/link"
import {Plural} from "@lingui/react/macro"
import styles from "./styles.module.css"
import SmartImage from "./SmartImage"
import {buildCategoryUrl, pickCategoryImage} from "./utils"

export default function CategoryCard({context, category}) {
    if (!category) return null
    const href = buildCategoryUrl(context, category.aid)
    const subtitles = (category.children || []).slice(0, 3).map(c => c.title).filter(Boolean)
    const image = pickCategoryImage(category)
    const initial = (category.title || "?").trim().charAt(0).toUpperCase()

    return (
        <Link href={href} passHref legacyBehavior>
            <a className={styles.categoryCard}>
                <span style={{display:"block"}} className={styles.categoryCardCover}>
                    <SmartImage
                        src={image}
                        alt={category.title || ""}
                        className={styles.categoryCardImage}
                        loading="lazy"
                        fallback={<span style={{display:"block"}} className={styles.categoryCardImagePlaceholder}>{initial}</span>}
                    />
                </span>
                <span style={{display:"block"}} className={styles.categoryCardBody}>
                    <h3 className={styles.categoryCardTitle}>{category.title}</h3>
                    <span style={{display:"block"}} className={styles.categoryCardCount}>
                        <Plural value={category.n_articles || 0} one="# article" other="# articles"/>
                    </span>
                    {subtitles.length > 0 && (
                        <span style={{display:"block"}} className={styles.categoryCardSubs}>
                            {subtitles.join(" · ")}
                        </span>
                    )}
                </span>
            </a>
        </Link>
    )
}
